import script from "./TeamLimitsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamLimitsTable.vue?vue&type=script&lang=ts&setup=true"

import "./TeamLimitsTable.vue?vue&type=style&index=0&id=f07529e2&lang=sass"

const __exports__ = script;

export default __exports__